import angular from 'angular';
const ngRoute = require('angular-route');
import routing from './messages.routes';
var localisations = require('./messages.localisations');
const anchorme = require("anchorme").default;

export class MessagesController {
  constructor(GLOBALS, $http, $scope, socket, common, Auth, subjects, $location, groups, $timeout, $routeParams, $sce, $interval) {
    'ngInject';
    var that = this;
    this.$http = $http;
    this.socket = socket;
    this.$scope = $scope;
    this.location = $location;
    this.$timeout = $timeout;
    this.$routeParams = $routeParams;
    this.common = common;
    this.common.setPageTitle('');
    if (typeof this.$routeParams.group != 'undefined') {
      this.common.setBack(`/group/${this.$routeParams.group}`, 'people');
    } else {
      //this.common.setBack('/group', 'people');
      // Set pre course
      let hour = new Date().getHours();
      if(hour >= 0 && hour <= 12) {
        this.common.setBack('https://docs.google.com/forms/d/1W6HERCp1Ge05F70k2euO2vZFNmHi3vrdztyxFynyAG4/edit?ts=6641ccd3', 'list');
      } else {
        // Set pre course
        this.common.setBack('https://docs.google.com/forms/d/1Ddoc5iV69VQJ86iCjCUkkmAdhIT9HvArGUCkY8Csu1g/edit?ts=6641ccc3', 'list');
      }
    }
    this.msgLength = GLOBALS.msgLength;
    this.groups = groups;
    this.messages = [];
    this.placeholder = 'What do you think?';
    this.isAdmin = Auth.isAdminSync;
    this.isModerator = Auth.isModeratorSync;
    this.Auth = Auth;
    Auth.getCurrentUser(function(user) {
      that.currentUser = user;
      that.showIntro = !that.currentUser.viewedIntro;
      if (!that.currentUser.opinionProfile.completed) {
        that.location.path('/dashboard');
      } else {
        if (typeof that.$routeParams.group != 'undefined') {
          that.groupId = that.$routeParams.group;
        } else {
          that.groupId = that.currentUser.group;
        }
        if (typeof that.groupId !== 'undefined' && that.groupId != '') {
          that.groups.myInitialise(that.groupId, that.currentUser._id, function(){
            that.messages = that.groups.getMessages();
            console.log('I have messages', that.messages);
            that.currentTopic = that.groups.getTopTopic();
            if (!that.groups.postable() && that.currentUser.role != 'admin' && that.currentUser.role != 'moderator' && !that.groups.singleStream()) {
              that.placeholder = 'Send messages not permitted at present.';
            }
            that.introVideo = that.groups.getVideoLink();
            common.setLoading(false);
            that.nogroup = false;
            that.scrollToBottom();
          }, function() {
            common.setLoading(false);
            that.nogroup = true;
          });
        } else {
          that.nogroup = true;
        }
      }
    });
    this.localisations = localisations[this.common.getLocale()];
    this.newMessage = '';
    this.isOpen = false;
    this.replyingTo = '';
    this.replyingMessage = '';
    this.messageUpload = null;
    this.previewedImage = null;
    this.showInput = true;
    this.starttime = GLOBALS.starttime;
    this.endtime = GLOBALS.endtime;
    if (!this.isAdmin() && !this.isModerator()) {
      var start = new Date();
      start.setHours(this.starttime[0],this.starttime[1],this.starttime[2]);
      var end = new Date();
      end.setHours(this.endtime[0],this.endtime[1],this.endtime[2]);
      var now = new Date();
      if (start.getTime() > now.getTime() || end.getTime() < now.getTime()) {
          console.log('Oooo bad boy.  Logging out')
          if (this.location.path() != '/login') {
            this.location.path('/closed');
          }
          this.Auth.logout();
      } else {
        console.log('Not logging out')
      }
    }

    // SET UP LISTENER FOR FILE UPLOAD - ANGULAR BINDINGS NOT READY IN FILEUPLAOD
    if(window.File && window.FileReader && window.FileList && window.Blob) {
      document.getElementById('messageFile').addEventListener('change', function() {
        that.uploadNewImage();
      }, false);
    } else {
      that.common.setAlert('File Upload Error', 'danger', 'The File APIs are not fully supported in this browser. Please get with the programme and use a modern browser! :) ', false, true);
    }
  }

  dontShowAgain() {
    console.log('DON"T SHOW');
    this.showIntro = false;
    this.Auth.hideIntro();
  }

  uploadNewImage() {
    var that = this;
    var file = document.getElementById('messageFile').files[0];
    if(file) {
      that.common.setLoading(true);
      var reader = new FileReader();

      reader.onload = function(readerEvt) {
        var binaryString = readerEvt.target.result;
        that.messageUpload = btoa(binaryString);
        console.log('that.messageUpload', that.messageUpload);
        that.$scope.$apply();
        that.common.setLoading(false);
      };
      reader.readAsBinaryString(file);
    }
  }

  removeImage() {
    this.messageUpload = null;
  }

  showPreview(imageB64) {
    this.previewedImage = imageB64;
  }

  closePreview() {
    this.previewedImage = null;
  }

  openInput() {
      this.showInput = !this.showInput;
  }

  sanitizeHtmlOutput(text) {
    return $sce.trustAsHtml(anchorme(text));
  }

  jumpTo(hash, e){
    e.preventDefault();
    this.scrollTo(hash);
  }

  previousTopic() {
    if (this.currentTopic > 0){
      this.currentTopic = this.currentTopic - 1;
    }
    this.clearReplyTo();
  }

  nextTopic() {
    if (this.currentTopic < this.groups.getTopTopic()){
      this.currentTopic = this.currentTopic + 1;
    }
    this.clearReplyTo();
  }

  printTopic() {
    this.groups.printTopicPdf(this.currentTopic, function(){}, function(){});
  }

  saveReaction(msgId, reaction) {
    this.groups.addReactionToMessage(reaction, this.currentUser._id, msgId, function(){}, function(){});
  }

  lineBreaks(value) {
    return value.replace(/\n/g, "<br/>").replace(/\r/g, "<br/>");
  }

  sendMessage() {
    var that = this;
    if(!that.groups.postable() && !that.groups.singleStream()) {
      that.placeholder = 'Sending messages not permitted at present.';
    } else if(this.newMessage.length <= 0) {
      return;
    } else {
      this.groups.postNewMessage(this.newMessage, this.replyingTo, this.replyingMessage, this.messageUpload, false, function(){
        that.newMessage = '';
        that.messageUpload = null;
        that.clearReplyTo();
        that.scrollToBottom();
      }, function() {});
    }
  }

  replyToMessage(msgId, message) {
    this.replyingTo = msgId;
    this.replyingMessage = message;
  }

  removeMessage(msgId, message) {
    var that = this;
    this.common.setAlert('Are you sure?', 'warning', 'Do you want to remove this message from this group?', false, false, true, function(){
      that.common.setLoading(true);
      that.groups.removeMessageFromGroup(msgId, function(){
        that.common.setLoading(false);
      }, function(){
        that.common.setLoading(false);
      });
    },function(){});
  }

  clearReplyTo() {
    this.replyingTo = '';
    this.replyingMessage = '';
  }

  scrollTo(id) {
      var el = document.getElementById(id);
      console.log(el);
      console.log(el.scrollHeight);
      window.scrollTo(0,el.scrollHeight);
  }

  scrollToBottom() {
    console.log('scrooling to the bottom', document.body.scrollHeight);
    this.$timeout(function() {
      window.scrollTo(0, document.body.scrollHeight);
    }, 500);
  }
}

export default angular.module('ffApp.messages', [ngRoute])
  .config(routing)
  .component('messages', {
    template: require('./messages.html'),
    controller: MessagesController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messages/messages.component.js